import { Paper, Tabs } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import * as React from 'react';
import { getColorMantine } from '../../../../../../react-commons/components/inputs/text-fields/types';
import { ValidationEntrySeverity } from '../../../../../../react-commons/components/ValidationEntrySeverity';
import { ValidationType } from '../../../../resource/enumerations/ValidationType';
import {
    SideEffectDeletionValidationResult,
    SideEffectValidationResult,
    SideEffectValidationResultMap,
} from '../../../../resource/resources/validation/mutationValidationResource';
import { compareValidationSeverity } from '../../../util/utilFunctions';
import { SideEffectResultComponent } from './SideEffectResultComponent';

export const SideEffectResultMapComponent= ({ sideEffectResultMap }: {
    sideEffectResultMap: SideEffectValidationResultMap;
}) => {
    const [selectedValidationType, setSelectedValidationType] = React.useState<string | null>(
        sideEffectResultMap?.addResourceValidationResults ? ValidationType.CREATION
        : sideEffectResultMap?.updateResourceValidationResults ? ValidationType.UPDATE
        : sideEffectResultMap?.deleteResourceValidationResults ? ValidationType.DELETE
        : ValidationType.CREATION
    );

    const getMaxSeverityOfSideEffectCategory = (
        categoryResult: Record<string, Array<SideEffectValidationResult | SideEffectDeletionValidationResult>> | null
    ) => {
        if (categoryResult) {
            let currentMax: ValidationEntrySeverity | undefined;
            for (const validationEntry of Object.values(categoryResult)) {
                for (const dep of validationEntry) {
                    const max = dep.validationResult?.maxSeverity ?? undefined;

                    if (max === ValidationEntrySeverity.FATAL) {
                        return max;
                    }
                    if (max !== undefined && (!currentMax || compareValidationSeverity(currentMax, max) > 0)) {
                        currentMax = max;
                    }
                }
            }
            return currentMax;
        }
        return undefined;
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
            }}
        >
            <Tabs value={selectedValidationType} onChange={setSelectedValidationType}>
                <Tabs.List>
                    {sideEffectResultMap?.addResourceValidationResults && (
                        <Tabs.Tab
                            value={ValidationType.CREATION}
                            style={{ height: 28, minHeight: 28 }}
                            rightSection={
                                <IconExclamationCircle
                                    color={getColorMantine(
                                        getMaxSeverityOfSideEffectCategory(
                                            sideEffectResultMap?.addResourceValidationResults
                                        )
                                    )}
                                />
                            }
                        >
                            Creation
                        </Tabs.Tab>
                    )}
                    {sideEffectResultMap?.updateResourceValidationResults && (
                        <Tabs.Tab
                            value={ValidationType.UPDATE}
                            style={{ height: 28, minHeight: 28 }}
                            rightSection={
                                <IconExclamationCircle
                                    color={getColorMantine(
                                        getMaxSeverityOfSideEffectCategory(
                                            sideEffectResultMap?.updateResourceValidationResults
                                        )
                                    )}
                                />
                            }
                        >
                            Update
                        </Tabs.Tab>
                    )}
                    {sideEffectResultMap?.deleteResourceValidationResults && (
                        <Tabs.Tab
                            value={ValidationType.DELETE}
                            style={{ height: 28, minHeight: 28 }}
                            rightSection={
                                <IconExclamationCircle
                                    color={getColorMantine(
                                        getMaxSeverityOfSideEffectCategory(
                                            sideEffectResultMap?.deleteResourceValidationResults
                                        )
                                    )}
                                />
                            }
                        >
                            Delete
                        </Tabs.Tab>
                    )}
                </Tabs.List>
                <Tabs.Panel value={ValidationType.CREATION}>
                    <Paper withBorder>
                        <SideEffectResultComponent
                            sideEffectResult={sideEffectResultMap.addResourceValidationResults}
                        />
                    </Paper>
                </Tabs.Panel>
                <Tabs.Panel value={ValidationType.UPDATE}>
                    <Paper withBorder>
                        <SideEffectResultComponent
                            sideEffectResult={sideEffectResultMap.updateResourceValidationResults}
                        />
                    </Paper>
                </Tabs.Panel>
                <Tabs.Panel value={ValidationType.DELETE}>
                    <Paper withBorder>
                        <SideEffectResultComponent
                            sideEffectResult={sideEffectResultMap.deleteResourceValidationResults}
                        />
                    </Paper>
                </Tabs.Panel>
            </Tabs>
        </div>
    );
};


